import React from 'react'
import { fieldIdentifiers } from 'components/Shared/Comment'
import { useNewTranslation } from 'hooks'
import { TFunction } from 'i18next'
import { FormikRadioButtonGroup } from 'particles/RadioButton/Group'
import { PLATFORM_CONTENT_TYPE_ENUM } from 'services/api/constants'
import { CampaignTemplateStep, OBJECTIVE } from 'state/campaignTemplates'

export const getRequirePurchaseOptions = (t: TFunction) => {
    return [
        {
            value: true,
            label: t('campaign.template.purchaseNeeds.yes'),
        },
        {
            value: false,
            label: t('campaign.template.purchaseNeeds.no'),
        },
    ]
}

export const getPostPlatformOptions = (t: TFunction, objective?: number | null) => {
    const options = [
        {
            value: PLATFORM_CONTENT_TYPE_ENUM.INSTAGRAM_STORY,
            label: t('taskType.instagramStory'),
        },
        {
            value: PLATFORM_CONTENT_TYPE_ENUM.INSTAGRAM_POST,
            label: t('taskType.instagramPost'),
        },
        {
            value: PLATFORM_CONTENT_TYPE_ENUM.INSTAGRAM_REEL,
            label: t('taskType.instagramReels'),
        },
    ]

    if (objective === OBJECTIVE.awareness) {
        options.push({
            value: PLATFORM_CONTENT_TYPE_ENUM.TIKTOK_POST,
            label: t('socialMedia.platform.TikTok'),
        })
    }

    return options
}

export const getCredibilityOptions = (t: TFunction) => {
    return [
        {
            value: PLATFORM_CONTENT_TYPE_ENUM.FOLLOW_ACCOUNT,
            label: t('campaign.template.credibilityNeed.option.followers'),
        },
        {
            value: PLATFORM_CONTENT_TYPE_ENUM.WRITE_REVIEW,
            label: t('campaign.template.credibilityNeed.option.reviews'),
        },
    ]
}

export const getRequireCreateContentOptions = (t: TFunction) => {
    return [
        {
            value: true,
            label: t('campaign.template.platformPost.instagramStoryUCG.title.yes'),
        },
        {
            value: false,
            label: t('campaign.template.platformPost.instagramStoryUCG.no'),
        },
    ]
}

export type ReviewTypeFilter = 'review_text_only' | 'review_text_image'
export type ReviewPriorityFilter = 'review_no_approval' | 'review_with_approval'

export const getRequireWriteReviewOptions = (t: TFunction) => {
    return {
        type: [
            {
                value: 'review_text_only',
                label: t('campaign.template.credibilityNeed.option.reviews.reviewTpye.textOnly'),
            },
            {
                value: 'review_text_image',
                label: t('campaign.template.credibilityNeed.option.reviews.reviewTpye.textAndImage'),
            },
        ],
        priority: [
            {
                value: 'review_no_approval',
                label: t('campaign.template.credibilityNeed.option.reviews.priority.speedAndAuthenticuty'),
            },
            {
                value: 'review_with_approval',
                label: t('campaign.template.credibilityNeed.option.reviews.priority.detailAndStructured'),
            },
        ],
    }
}

export interface WriteReviewOptionsProps {
    isReadOnly?: boolean
}
export const WriteReviewOptions = ({ isReadOnly }: WriteReviewOptionsProps) => {
    const [t] = useNewTranslation()
    const { type, priority } = getRequireWriteReviewOptions(t)

    return (
        <>
            <FormikRadioButtonGroup
                name="review_type"
                title={t('campaign.template.credibilityNeed.option.reviews.reviewTpye.title')}
                options={type}
                isRequired
                isReadOnly={isReadOnly}
                labelSize="l"
                dataTestId="test-reviewTypeOption"
                identifier={`${CampaignTemplateStep.CAMPAIGN_REQUIREMENTS}_${fieldIdentifiers.templateReviewImage}`}
            />
            <FormikRadioButtonGroup
                name="review_priority"
                title={t('campaign.template.credibilityNeed.option.reviews.priority.title')}
                options={priority}
                isRequired
                isReadOnly={isReadOnly}
                labelSize="l"
                dataTestId="test-reviewPriorityOption"
                identifier={`${CampaignTemplateStep.CAMPAIGN_REQUIREMENTS}_${fieldIdentifiers.templateReviewApproval}`}
            />
        </>
    )
}
